// extracted by mini-css-extract-plugin
export default {"workOrderGridWrapper":"custom-ag-grid_workOrderGridWrapper__0GwRa"};